module.exports = __webpack_public_path__ + "static/media/righ-arrow.3fd56312.png";